/* eslint-disable max-lines-per-function */
import { Button } from '@/components/ui/button';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { useCreateAbschnitt } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateAbschnitt/useCreateAbschnitt';
import { toast } from '@/hooks/use-toast';
import { faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CreateAbschnitt({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const { t } = useTranslation();
  const [createAbschnitt] = useCreateAbschnitt();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const istLehrjahr = rotationsplan.beruf.istAusbildung;

  function handleClick() {
    setIsSubmitting(true);
    createAbschnitt({
      input: {
        name: istLehrjahr ? 'Lehrjahr' : 'Abschnitt',
        position: rotationsplan.abschnitte.length + 1,
        rotationsplanId: rotationsplan.id,
      },
    })
      .then((result) => {
        if (
          result.data.mitarbeiter_createAbschnitt.success &&
          result.data.mitarbeiter_createAbschnitt.success.abschnitt
        ) {
          toast({
            title: istLehrjahr
              ? t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.success.lehrjahr',
                )
              : t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.success.abschnitt',
                ),
          });
        } else {
          toast({
            title: istLehrjahr
              ? t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.error.lehrjahr',
                )
              : t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.error.abschnitt',
                ),
          });
        }
      })
      .catch(() => {
        toast({
          title: istLehrjahr
            ? t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.error.lehrjahr',
              )
            : t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.error.abschnitt',
              ),
        });
      })
      .finally(() => setIsSubmitting(false));
  }

  return (
    <div className="px-1 py-2 border-dashed border-neutrals-600 border rounded-md">
      <Button
        disabled={isSubmitting}
        className="w-full flex gap-2"
        variant="ghost"
        onClick={handleClick}>
        <FontAwesomeIcon icon={faPlusLarge} />
        {rotationsplan.beruf.istAusbildung
          ? t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.labelJahr',
            )
          : t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt.labelAbschnitt',
            )}
      </Button>
    </div>
  );
}
